import axios from 'axios'

// Add a request interceptor
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('BearerToken')
    // debugger
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    // config.headers['Content-Type'] = 'application/json';
    return config
  },
  error => {
    Promise.reject(error)
  }
)